// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"ReportModal_modalOverlay__fn1vJ","modalContent":"ReportModal_modalContent__2ZVmX","closeButton":"ReportModal_closeButton__2lAxG"};